import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="local-time"
// Appends the viewer's local time when their time zone differs from the one the
// server rendered, e.g. "9:40 AM BST (1:40 PM your time)".
export default class extends Controller {
  static targets = ["local"]
  static values = { offset: Number, end: String } // server's UTC offset in minutes; optional range end

  connect() {
    const date = new Date(this.element.getAttribute("datetime"))
    if (isNaN(date) || -date.getTimezoneOffset() === this.offsetValue) return

    const time = (d) => d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true })
    const serverDay = new Date(date.getTime() + this.offsetValue * 60000).getUTCDate()
    let local = time(date)
    if (this.hasEndValue) local += ` - ${time(new Date(this.endValue))}`
    if (serverDay !== date.getDate()) {
      local = `${date.getDate()} ${date.toLocaleString("en-US", { month: "short" })}, ${local}`
    }

    this.localTarget.textContent = ` (${local} your time)`
  }
}
